/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import createTrack from 'services/actions/tracker_actions';
import {
  fmtBRL,
  fmtDataBR,
  fmtInt,
  Regime,
  SearchHit,
  unidadeLabel,
  valorUnitarioDe,
} from 'services/price_intelligence';
import PriceIntelligenceBiddingModal from 'components/molecules/price_intelligence_bidding_modal';
import { Container } from './styles';

export type CampoOrdenacao = 'valor' | 'data';
export type SortMode = 'relevancia' | 'valor_asc' | 'valor_desc' | 'data_desc' | 'data_asc';

const ORIGEM_DO_ESCOPO: Record<string, string> = {
  descricao: 'Preço derivado da metragem declarada na descrição do item',
  objeto: 'Preço estimado: valor do item ÷ metragem declarada no objeto da licitação',
  edital: 'Preço estimado: valor do item ÷ metragem encontrada no edital da licitação',
  unidade_informada: 'Preço na unidade física informada pelo portal',
};

const tooltipDoEdital = (hit: SearchHit): string =>
  [
    hit.confirmado_pelo_edital
      ? 'Descrição genérica no portal — especificação confirmada pela IA no texto do edital.'
      : null,
    hit.edital_resumo,
    hit.edital && hit.edital.item_edital ? `Referência no edital: ${hit.edital.item_edital}` : null,
    hit.edital && hit.edital.trecho ? `Trecho: ${hit.edital.trecho}` : null,
    hit.edital && hit.edital.numero ? `Edital ${hit.edital.numero}` : null,
  ]
    .filter(Boolean)
    .join('\n\n');

interface PriceIntelligenceSampleTableProps {
  hits: SearchHit[];
  regime?: Regime;
  selecionados?: Set<string | number>;
  onToggle?: (id: string | number) => void;
  onToggleTodos?: () => void;
  todosSelecionados?: boolean;
  ordenacao?: SortMode;
  onOrdenar?: (campo: CampoOrdenacao) => void;
}

const PriceIntelligenceSampleTable = ({
  hits,
  regime,
  selecionados,
  onToggle,
  onToggleTodos,
  todosSelecionados,
  ordenacao,
  onOrdenar,
}: PriceIntelligenceSampleTableProps) => {
  const selecionavel = Boolean(selecionados && onToggle);
  const [amostraAberta, setAmostraAberta] = useState<SearchHit | null>(null);

  const abrirAmostra = (hit: SearchHit) => {
    createTrack('Análise de Preços - Abriu resultado da licitação', {
      licitacao_id: hit.payload.licitacao_id,
    });
    setAmostraAberta(hit);
  };

  const cabecalhoOrdenavel = (campo: CampoOrdenacao, rotulo: string, alinharDireita = false) => {
    const ativo = ordenacao ? ordenacao.indexOf(campo) === 0 : false;
    const icone =
      ativo && ordenacao && ordenacao.indexOf('asc') > 0 ? 'arrow_upward' : 'arrow_downward';
    return (
      <th style={alinharDireita ? { textAlign: 'right' } : undefined}>
        {onOrdenar ? (
          <button
            type="button"
            className={`sort-btn ${ativo ? 'active' : ''}`}
            onClick={() => onOrdenar(campo)}
            title={`Ordenar por ${rotulo.toLowerCase()}`}
          >
            {rotulo}
            <i className="material-icons">{icone}</i>
          </button>
        ) : (
          rotulo
        )}
      </th>
    );
  };

  return (
    <Container>
      <table className="table">
        <thead>
          <tr>
            {selecionavel && (
              <th style={{ width: 36 }}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={Boolean(todosSelecionados)}
                  onChange={() => onToggleTodos && onToggleTodos()}
                  aria-label="Selecionar todas as amostras visíveis"
                />
              </th>
            )}
            <th>Descrição</th>
            <th>Órgão / Local</th>
            <th>Fornecedor</th>
            <th>Un.</th>
            {cabecalhoOrdenavel('valor', 'Valor unit.', true)}
            {cabecalhoOrdenavel('data', 'Data')}
            <th aria-label="Detalhes" />
          </tr>
        </thead>
        <tbody>
          {hits.map((hit) => {
            const valor = valorUnitarioDe(hit);
            const cnpj = (hit.payload.cnpj || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
            const selecionada = Boolean(selecionados && selecionados.has(hit.id));
            const marcaModelo = [hit.payload.marca, hit.payload.modelo].filter(Boolean).join(' · ');
            const normalizado =
              regime && regime !== 'produto' && hit.preco_normalizado && hit.unidade_preco
                ? hit.preco_normalizado
                : null;
            const temEdital = hit.confirmado_pelo_edital || (hit.edital && hit.edital.disponivel);

            return (
              <tr
                key={String(hit.id)}
                className={`${selecionavel ? 'selectable' : ''} ${selecionada ? 'selected' : ''}`}
                onClick={() => selecionavel && onToggle && onToggle(hit.id)}
              >
                {selecionavel && (
                  <td onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={selecionada}
                      onChange={() => onToggle && onToggle(hit.id)}
                      aria-label="Selecionar amostra"
                    />
                  </td>
                )}
                <td className="desc-cell">
                  <div
                    className="desc-main"
                    title={hit.payload.item_descricao_detalhado || hit.payload.item_descricao}
                  >
                    {hit.payload.item_descricao || '—'}
                  </div>
                  {marcaModelo && <div className="desc-extra">{marcaModelo}</div>}
                  {temEdital && (
                    <span
                      className={`edital-badge ${hit.confirmado_pelo_edital ? '' : 'neutral'}`}
                      title={tooltipDoEdital(hit) || 'Edital da licitação disponível'}
                    >
                      <i className="material-icons">
                        {hit.confirmado_pelo_edital ? 'verified' : 'description'}
                      </i>
                      {hit.confirmado_pelo_edital ? 'Confirmado no edital' : 'Edital'}
                    </span>
                  )}
                </td>
                <td className="org-cell">
                  <div className="org-name" title={hit.payload.orgao_nome}>
                    {hit.payload.orgao_nome || '—'}
                  </div>
                  <div className="org-place">
                    {[hit.payload.municipio, hit.payload.uf].filter(Boolean).join('/') || '—'}
                  </div>
                </td>
                <td className="supplier-cell" onClick={(e) => e.stopPropagation()}>
                  {cnpj ? (
                    <Link
                      to={`/concorrente/${cnpj}`}
                      title="Ver ficha do concorrente"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={() =>
                        createTrack('Análise de Preços - Clicou em concorrente', {
                          origem: 'tabela',
                        })
                      }
                    >
                      {hit.payload.fornecedor || cnpj}
                    </Link>
                  ) : (
                    <span className="supplier-plain">{hit.payload.fornecedor || '—'}</span>
                  )}
                </td>
                <td>{hit.payload.item_unidade || hit.item_unidade_norm || '—'}</td>
                <td className="value-cell">
                  <span className="value-main">{valor !== null ? fmtBRL(valor) : '—'}</span>
                  {normalizado !== null && (
                    <span
                      className="value-normalized"
                      title={(hit.escopo && ORIGEM_DO_ESCOPO[hit.escopo.fonte]) || undefined}
                    >
                      ≈ {fmtBRL(normalizado)}/{unidadeLabel(hit.unidade_preco)}
                      {hit.escopo && hit.escopo.qtd
                        ? ` · ${fmtInt(hit.escopo.qtd)} ${unidadeLabel(hit.escopo.unidade)}`
                        : ''}
                    </span>
                  )}
                </td>
                <td className="date-cell">{fmtDataBR(hit.payload.created)}</td>
                <td className="link-cell" onClick={(e) => e.stopPropagation()}>
                  <button
                    type="button"
                    title="Detalhes da amostra e resultado da licitação"
                    onClick={() => abrirAmostra(hit)}
                  >
                    <i className="material-icons">visibility</i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <PriceIntelligenceBiddingModal hit={amostraAberta} onClose={() => setAmostraAberta(null)} />
    </Container>
  );
};

export default PriceIntelligenceSampleTable;
